import React, { Component } from 'react';
import queryString from 'query-string';

import Utils from '../../utils/utils';

import { 
    Box,
    Grid,
    Icon
} from '@material-ui/core';

import {
    Container,
    Row,
    Col,
    Button,
} from 'react-bootstrap';
import styled from 'styled-components';

import { connect } from 'react-redux'
import publicIframe from "./redux/publicIframe";

import { ProformaInvoiceStatus } from '../../v5/utils/enums';

import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin, ToolbarSlot } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


const StyledAcceptDecline = styled.div`
    width: 300px;
    margin: 0 auto;
    border: 1px solid #DEDEE1;
    border-radius: 6px;
    padding: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    position: sticky;
    top: 16px;

    button {
        width: 100%;
    }
`;

const StyledPdfDiv = styled.div`
    ${(props: any) => {
        if(props.type == 1){
            return `
                height: 100vh;
            `
        } else {
            return `
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                zIndex: 99999;
            `
        }
    }}
`;


const workerUrl = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';

const PDFViewer = ({ fileUrl, type }) => {
    const defaultLayout = defaultLayoutPlugin({
        sidebarTabs: (defaultTabs) => {
            return [];
        },
        renderToolbar: (Toolbar) => {
            return <Toolbar>
                {(slots: ToolbarSlot) => (
                    <Grid container justifyContent={'center'} alignItems={'center'}>
                        <Grid item>
                            <Grid xs={12}>
                                <Box style={{ textAlign: 'center', fontSize: '30px' }}>
                                    <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center', gap: '12px', textAlign: 'center' }}>
                                        {slots.ZoomOut && slots.ZoomOut()}
                                        {slots.ZoomIn && slots.ZoomIn()}
                                        {slots.Print && slots.Print()}
                                        {slots.Download && slots.Download()}
                                    </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Toolbar>
        },
    });

    return (
        <StyledPdfDiv
            type={type}
        >
            <Worker workerUrl={workerUrl}>
                <Viewer fileUrl={fileUrl} plugins={[defaultLayout]} defaultScale={1.4} />
            </Worker>
        </StyledPdfDiv>
    );
};


class PublicIframe extends Component {
	
	constructor(props){
		super(props);

        let q = queryString.parse(window.location.search);
        let uuid = q.uuid ? q.uuid : "";
        let url = q.url ? q.url : "job/preview/" + uuid;
        let method = q.method ? q.method : "get";
        let type = q.type ? q.type : 0;

		this.state = {
            uuid: uuid,
            url: url,
            method: method,
            type: type,
		}
	}


    componentDidMount() {
        if(this.state.type == 1){
            this.props.action.publicIframe.callProformaGetByTokenApi(this.state.uuid, (state: boolean, data: any) => {});
        } else {
            this.props.action.publicIframe.callPreviewApi({ data: null, path: this.state.url, method: this.state.method, type: this.state.type });
        }
    }


    proformaInvoice = () => {
        let isNotAcceptedDeclined = ((this.props.publicIframe.proformaStatus !== ProformaInvoiceStatus.Accepted) && (this.props.publicIframe.proformaStatus !== ProformaInvoiceStatus.Declined));

        return <Container fluid="md" className='wp-v5'>
            <Row>
                <Col xs={{ span: 12, order: 2 }} md={{ span: 8, order: 1, offset: isNotAcceptedDeclined ? 0 : 2 }}>
                    <PDFViewer fileUrl={this.props.publicIframe.url} type={this.state.type} />
                </Col>
                {(isNotAcceptedDeclined) && <Col xs={{ span: 12, order: 1 }} md={{ span: 4, order: 2 }} className='text-center'>
                    <StyledAcceptDecline>
                        <Row className='g-8'>
                            <Col xs={12} className='text-center mb-16'>Accept or Decline</Col>
                            <Col xs={12}>
                                <Button
                                    variant={'custom-primary'}
                                    size={'sm'}
                                    disabled={false}
                                    onClick={(e) => {
                                        this.props.action.publicIframe.callProformaAcceptApi(this.state.uuid, (state: boolean, data: any) => {
                                            if(state){
                                                window.location.reload()
                                            }
                                        });
                                    }}
                                >ACCEPT</Button>
                            </Col>
                            <Col xs={12}>
                                <Button
                                    variant={'custom-secondary-danger'}
                                    size={'sm'}
                                    disabled={false}
                                    onClick={(e) => {
                                        this.props.action.publicIframe.callProformaDeclineApi(this.state.uuid, (state: boolean, data: any) => {
                                            if(state){
                                                window.location.reload()
                                            }
                                        });
                                    }}
                                >DECLINE</Button>
                            </Col>
                        </Row>
                    </StyledAcceptDecline>
                </Col>}
            </Row>
        </Container>
    }


	render() {
        if(this.props.publicIframe.isLoading){
            return <Grid container justifyContent={'center'} alignItems={'center'} style={{ height: '100vh' }}>
                <Grid item>
                    <Grid xs={12}>
                        <Box style={{ textAlign: 'center', fontSize: '30px' }}>Please Wait</Box>
                        <Box textAlign={'center'}>
                            <Icon component={'i'} style={{ fontSize: '55px' }}>more_horiz</Icon>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        } else {
            if(this.props.publicIframe.url){
                if(this.state.type == 1){
                    return this.proformaInvoice()
                } else {
                    return <PDFViewer fileUrl={this.props.publicIframe.url} />
                }
            } else {
                return <Grid container justifyContent={'center'} alignItems={'center'} style={{ height: '100vh' }}>
                    <Grid item>
                        <Grid xs={12}>
                            <Box style={{ textAlign: 'center', fontSize: '30px' }}>{(this.props.publicIframe.error && this.props.publicIframe.error != '') ? this.props.publicIframe.error : 'Link Expired'}</Box>
                            <Box textAlign={'center'}>
                                <Icon component={'i'} style={{ fontSize: '55px' }}>error</Icon>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            }
        }
	}
}


const mapStateToProps = state => {
    return {
        ...state,
        ...Utils.mapStateToProps(state),
    };
};
  
const mapDispatchToProps = (dispatch) => ({
    action: {
        publicIframe: {
            callPreviewApi: (payload) => dispatch(publicIframe.callPreviewApi(payload)),

            callProformaGetByTokenApi: (payload, callback) => dispatch(publicIframe.callProformaGetByTokenApi(payload, callback)),
            callProformaAcceptApi: (payload, callback) => dispatch(publicIframe.callProformaAcceptApi(payload, callback)),
            callProformaDeclineApi: (payload, callback) => dispatch(publicIframe.callProformaDeclineApi(payload, callback)),
        },
    }
});
  
  
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PublicIframe);
